{
	"title": "Η υπηρεσία δεν είναι διαθέσιμη (500)",
	"description": "Προσπαθήστε να ανανεώσετε αυτήν τη σελίδα ή ελέγξτε τη σύνδεσή σας στο Διαδίκτυο. Εάν αυτό το σφάλμα επιμένει, αναφέρετέ το ως σφάλμα, ώστε να μπορέσουμε να λάβουμε μέτρα.",
	"primaryButtonTitle": "Ανανέωση σελίδας",
	"secondaryButtonTitle": "Αντιγραφή αρχείου καταγραφής σφαλμάτων",
	"errorLogCopiedMessage": "Το αρχείο καταγραφής σφαλμάτων αντιγράφηκε",
	"traceparentLabel": "Traceparent"
}
